import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let live = true;
    // CRITICAL: returning from OAuth callback — AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then(({ data }) => { if (live) setUser(data); })
      .catch(() => {})
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);
  return { user, loading };
}

export function useFavorites(user) {
  const [favorites, setFavorites] = useState([]);
  useEffect(() => {
    if (!user) {
      setFavorites([]);
      return;
    }
    api.get("/my/favorites").then(({ data }) => setFavorites(data.team_slugs || [])).catch(() => {});
  }, [user?.email]);
  const toggleFavorite = async (slug) => {
    const next = favorites.includes(slug) ? favorites.filter((s) => s !== slug) : [...favorites, slug];
    setFavorites(next);
    try {
      await api.post("/my/favorites", { team_slugs: next });
    } catch {
      setFavorites(favorites);
    }
  };
  return { favorites, toggleFavorite };
}

export function GoogleIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z" />
      <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
    </svg>
  );
}

export function GoogleSignInButton({ label = "Sign in with Google", className = "" }) {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={signIn}
      data-testid="google-signin-btn"
      className={`flex items-center justify-center gap-2 rounded-sm border border-bline bg-surface px-4 py-2 font-display text-sm tracking-widest text-white transition-colors hover:border-volt hover:text-volt ${className}`}
    >
      <GoogleIcon />
      {label.toUpperCase()}
    </button>
  );
}
